import { Camera } from 'lucide-react';
import GenericModulePage from './GenericModulePage';
import { imagingAPI } from '../lib/api';

const config = {
  title: 'Imaging / Radiology',
  subtitle: 'X-Ray · CT · MRI · USG orders and reports.',
  icon: Camera,
  permPrefix: 'imaging',
  testId: 'imaging',
  idLabel: 'Study',
  fields: [
    { key: 'patient_name', label: 'Patient Name', type: 'text', required: true, listColumn: true },
    { key: 'patient_uhid', label: 'UHID', type: 'text', listColumn: true },
    { key: 'modality', label: 'Modality', type: 'select', options: ['X-Ray', 'CT', 'MRI', 'Ultrasound', 'Mammography', 'Other'], required: true, listColumn: true },
    { key: 'body_part', label: 'Body Part', type: 'text', placeholder: 'Chest / Abdomen / Skull', listColumn: true },
    { key: 'referred_by', label: 'Referred By', type: 'text', placeholder: 'Dr. …' },
    { key: 'scheduled_at', label: 'Scheduled At', type: 'date' },
    { key: 'status', label: 'Status', type: 'select', options: ['Ordered', 'In Progress', 'Reported', 'Cancelled'], listColumn: true },
    { key: 'findings', label: 'Findings / Impression', type: 'textarea', fullWidth: true },
  ],
};

export default function ImagingPage() {
  return <GenericModulePage config={config} apiClient={imagingAPI} />;
}
